<template>
  <div>
    <label>
      <span class="title">{{ title }} </span>
      <span class="required" v-if="required">*</span>
    </label>
    <div>
      <div class="select" :class="{ border: showBorder, classCss }">
        <multiselect @open="onOpen" @select="onSelected" @search-change="onSearch" :options="data"
          v-model.trim="currentValue" :custom-label="label" :disabled="disabled" placeholder :showLabels="true"
          :noResult="false" ref="multiselect" selectLabel deselectLabel selectedLabel>
          <div slot="beforeList" class="after-list">
            <Button v-if="showBtnClean" key="cleanSelect" title="Limpar" type="warning" classIcon="fas fa-broom"
              size="small" :clicked="cleanSelectStatic" />
          </div>
        </multiselect>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import Button from "./Button.vue";

import { mapMutations, mapGetters } from "vuex";

export default {
  name: "SelectStatic",
  props: {
    title: String,
    formName: String,
    classCss: String,
    field: String,
    initialFieldTarget: Object,
    fieldTarget: String,
    required: Boolean,
    initialValue: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyQuery: {
      type: Boolean,
      default: false,
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
    showBtnClean: {
      type: Boolean,
      default: false,
    },
    markFormDirty: {
      type: Boolean,
      default: false,
    },
    data: Array,
    value: Object,
  },
  components: {
    Multiselect,
    Button,
  },
  data() {
    return {
      currentValue: this.initialValue,
      notifications: [],
    };
  },
  created() {
    this.validate();
  },
  mounted() {
    let el = this.$el.getElementsByClassName("multiselect")[0];
    if (el) {
      el.tabIndex = 0;
    }

    if (this.initialFieldTarget.id) {
      let value = this.initialFieldTarget.id;
      let obj = { tag: `${this.title}: ${value}`, fieldTarget: this.fieldTarget, value: value };
      this.addFilter(obj);
    }

  },
  computed: {
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", ["addFilter", "removeLoading"]),
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "resetValidation",
      "updateFormDirty",
    ]),
    onOpen() { },
    onSelected(value) {
      this.$emit("input", value);
      let obj = { fieldTarget: this.fieldTarget, value: value.id };
      if (!this.onlyQuery) this.addFilter(obj);
      if (this.fieldTarget && this.fieldTarget != "totalPerPage") {
        let obj = { tag: `${this.title}: ${value.content}`, fieldTarget: this.fieldTarget, value: value.id };
        this.addFilter(obj);
      }

      if (this.markFormDirty) this.updateFormDirty(true);
    },
    onSearch(value) { },
    label(value) {
      return `${value.content}`;
    },
    cleanSelectStatic() {
      let obj = { content: "", id: "" };
      this.currentValue = obj;
      this.$emit("input", obj);
      this.$refs.multiselect.deactivate();
      this.removeLoading(["cleanSelectStatic"]);

      if (this.fieldTarget) {
        let obj = { fieldTarget: this.fieldTarget, value: "" };
        this.addFilter(obj);
      }
    },

    validate() {
      this.notifications = [];
      if (this.required && !this.value.id) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "tagRemoved") {
          if (this.fieldTarget == event.data) this.cleanSelectStatic();
        }

      },
      deep: true,
    },
    "value.id": function () {
      this.validate();
      this.formDirty = true;
      if (this.markFormDirty) this.updateFormDirty(true);
      this.currentValue = { id: this.value.id, content: this.value.content };
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    "initialValue.id": function () {
      this.currentValue = { id: this.value.id, content: this.value.content };
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

div.after-list {
  padding: 8px;
}

.select {
  height: 38px;
  border-radius: 5px !important;
  margin-bottom: 20px;
}

.border {
  border: 1px solid #dbdee0 !important;
}
</style>
